/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-09-21 23:22:49
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2022-12-07 01:22:39
 * @FilePath: /wecalendar-web-component/packages/mobile/src/Dialog/index.tsx
 * @Description: 带样式的弹窗
 */
import ccDialog from "./dialog";
import "./index.scss";
export default ccDialog;